module.exports = __webpack_public_path__ + "static/media/caixa.75e5977d.png";